import { isoDateToLocalDate, toLocalISODate } from "../utils";

export const getTaskDayKey = (value?: string | null) => {
  if (!value) return "";
  const [datePart] = value.split("T");
  if (!datePart) return "";
  return toLocalISODate(isoDateToLocalDate(datePart));
};
